import { render, staticRenderFns } from "./FileThumbnailAdapter.vue?vue&type=template&id=284d20d7&"
import script from "./FileThumbnailAdapter.vue?vue&type=script&lang=js&"
export * from "./FileThumbnailAdapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports